import { resolveAmbiguousUserIdentityConflict } from '~src/app/actions/spaces/UserIdentityActions';
import { IdentityMigrationFailureType } from '~src/authentication/models/IdentityMigrationFailureType';
import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const ResolveAmbiguousUserIdentityConflictAction: IEntityAction<IUserIdentityConflictInfo, {}> = {
  name: EntityActionNames.ResolveAmbiguousUserIdentityConflict,
  translateName: Messages.identityMigration_ResolveAmbiguousUserIdentityConflictAction,
  isVisible: (targetItems: IUserIdentityConflictInfo[], state: AppState) => isAmbiguousUnacknowledgedConflict(targetItems),
  isClickable: (availableActions: {}, targetItems: IUserIdentityConflictInfo[], state: AppState) => isAmbiguousUnacknowledgedConflict(targetItems),
  createReduxAction: (targetItems: IUserIdentityConflictInfo[]) => resolveAmbiguousUserIdentityConflict(targetItems[0])
};

function isAmbiguousUnacknowledgedConflict(targetItems: IUserIdentityConflictInfo[]) {
  return targetItems[0] && !targetItems[0].acknowledged && targetItems[0].failureType === IdentityMigrationFailureType.AMBIGUOUS;
}

